var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SidebarLayout',{attrs:{"disable-sidebar-margin-right":""},scopedSlots:_vm._u([{key:"nav",fn:function(){return [_c('ReportsNav')]},proxy:true},{key:"body",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }